import './Terms.css'
import Accordion from '../common/components/accordion/Accordion';
import React from 'react';
import { Helmet } from 'react-helmet';

const disclaimers = [
  {
    title:
      <span className='terms-title'>Interpretation and definitions</span>,
    content:
      <React.Fragment>
        <div className='section'>
          <div className='title'>Interpretation</div>
          <p>
            The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.
          </p>
        </div>
        <div className='section'>
          <div className='title'>Definitions</div>
          <p>
            For the purposes of this Disclaimer:
            <br/>
            <span className='title'>Application</span> means the software program provided by the Company downloaded by You on any electronic device, named Sera.
            <br/>
            <span className='title'>Company</span> (referred to as either &quot;the Company&quot;, &quot;We&quot;, &quot;Us&quot; or &quot;Our&quot; in this Agreement) refers to Sera, LLC, San Francisco, CA 94103.
            <br/>
            <span className='title'>Service</span> refers to the Application or the Website or both.
            <br/>
            <span className='title'>Website</span> refers to Sera, accessible from <a href='https://getsera.io'>https://getsera.io</a>.
            <br/>
            <span className='title'>You</span> means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.
          </p>
        </div>
      </React.Fragment>
  },
  {
    title:
      <span className='terms-title'>Disclaimer</span>,
    content:
      <React.Fragment>
        <p>
          The information contained on the Service is for general information purposes only.
        </p>
        <p>
          The Company assumes no responsibility for errors or omissions in the contents of the Service.
        </p>
        <p>
          In no event shall the Company be liable for any special, direct, indirect, consequential, or incidental damages or any damages whatsoever, whether in an action of contract, negligence or other tort, arising out of or in connection with the use of the Service or the contents of the Service. The Company reserves the right to make additions, deletions, or modifications to the contents on the Service at any time without prior notice.
        </p>
        <p>
          The Company does not warrant that the Service is free of viruses or other harmful components.
        </p>
      </React.Fragment>
  },
  {
    title:
      <span className='terms-title'>External links disclaimer</span>,
    content:
      <React.Fragment>
        <p>
          The Service may contain links to external websites that are not provided or maintained by or in any way affiliated with the Company. Please note that the Company does not guarantee the accuracy, relevance, timeliness, or completeness of any information on these external websites.
        </p>
      </React.Fragment>
  },
  {
    title:
      <span className='terms-title'>Errors and omissions disclaimer</span>,
    content:
      <React.Fragment>
        <p>
          The information given by the Service is for general guidance on matters of interest only. Even if the Company takes every precaution to insure that the content of the Service is both current and accurate, errors can occur. Plus, given the changing nature of laws, rules and regulations, there may be delays, omissions or inaccuracies in the information contained on the Service.
        </p>
        <p>
          The Company is not responsible for any errors or omissions, or for the results obtained from the use of this information.
        </p>
      </React.Fragment>
  },
  {
    title:
      <span className='terms-title'>Fair use disclaimer</span>,
    content:
      <React.Fragment>
        <p>
          The Company may use copyrighted material which has not always been specifically authorized by the copyright owner. The Company is making such material available for criticism, comment, news reporting, teaching, scholarship, or research.
        </p>
        <p>
          The Company believes this constitutes a &apos;fair use&apos; of any such copyrighted material as provided for in section 107 of the United States Copyright law.
        </p>
        <p>
          If You wish to use copyrighted material from the Service for your own purposes that go beyond fair use, You must obtain permission from the copyright owner.
        </p>
      </React.Fragment>
  },
  {
    title:
      <span className='terms-title'>Views expressed disclaimer</span>,
    content:
      <React.Fragment>
        <p>
          The Service may contain views and opinions which are those of the authors and do not necessarily reflect the official policy or position of any other author, agency, organization, employer or company, including the Company.
        </p>
        <p>
          Comments published by users are their sole responsibility and the users will take full responsibility, liability and blame for any libel or litigation that results from something written in or as a direct result of something written in a comment. The Company is not liable for any comment published by users and reserves the right to delete any comment for any reason whatsoever.
        </p>
      </React.Fragment>
  },
  {
    title:
      <span className='terms-title'>No responsibility disclaimer</span>,
    content:
      <React.Fragment>
        <p>
          The information on the Service is provided with the understanding that the Company is not herein engaged in rendering legal, accounting, tax, or other financial or professional advice and services. As such, it should not be used as a substitute for consultation with professional accounting, tax, legal, financial or other competent advisers.
        </p>
        <p>
          In no event shall the Company or its suppliers be liable for any special, incidental, indirect, or consequential damages whatsoever arising out of or in connection with your access or use or inability to access or use the Service.
        </p>
      </React.Fragment>
  },
  {
    title:
      <span className='terms-title'>&#39;Use at your own risk&#39; disclaimer</span>,
    content:
      <React.Fragment>
        <p>
          All information in the Service is provided &quot;as is&quot;, with no guarantee of completeness, accuracy, timeliness or of the results obtained from the use of this information, and without warranty of any kind, express or implied, including, but not limited to warranties of performance, merchantability and fitness for a particular purpose.
        </p>
        <p>
          The Company will not be liable to You or anyone else for any decision made or action taken in reliance on the information given by the Service or for any consequential, special or similar damages, even if advised of the possibility of such damages.
        </p> 
      </React.Fragment>
  },
  {
    title:
      <span className='terms-title'>Contact us</span>,
    content:
      <React.Fragment>
        <p>
          If you have any questions about these Terms and Conditions, You can contact us by email: <a href='mailto:info@getsera.io'>info@getsera.io</a>
        </p>
      </React.Fragment>
  },
];

function Disclaimer() {
  return (
    <React.Fragment>
      <Helmet>
        <title>Sera - Disclaimer</title>
      </Helmet>
      <div className='terms-container'>
        <div className='terms'>
          <div className='title'>Disclaimer</div>
          <p className='last-updated accent'>Last updated: April 17, 2023</p>
          
          <Accordion header="" items={disclaimers} multipleOpen={true} />

        </div>
      </div>
    </React.Fragment>
  );
}

export default Disclaimer;